export const SOURCE_CHART_COLORS = [
    "#1d4ed8", "#065f46", "#b45309", "#be123c", "#3730a3",
    "#0891b2", "#7c3aed", "#ea580c", "#059669", "#6366f1",
];

export const OTHERS_COLOR = "#64748b";

export const isUnknownCategory = (name) => {
    const n = String(name || "").trim().toLowerCase();
    return !n || n === "unknown" || n === "unknown product/service";
};

export const formatShare = (value, total) => {
    if (!total) return "0%";
    const pct = (value / total) * 100;
    if (value > 0 && pct < 1) return "<1%";
    return `${Math.round(pct)}%`;
};

export const sortByValueDesc = (items) =>
    [...items].sort((a, b) => (b.value - a.value) || String(a.label).localeCompare(String(b.label)));

export const withChartColors = (items) =>
    items.map((item, i) => ({
        ...item,
        color: item.isOthers ? OTHERS_COLOR : (item.color || SOURCE_CHART_COLORS[i % SOURCE_CHART_COLORS.length]),
    }));

export const groupTopN = (items, topN = 5, othersLabel = "Others") => {
    const sorted = sortByValueDesc(items);
    if (sorted.length <= topN) {
        return { pieItems: withChartColors(sorted), groupedCount: 0, groupedValue: 0 };
    }
    const head = withChartColors(sorted.slice(0, topN));
    const tail = sorted.slice(topN);
    const groupedValue = tail.reduce((sum, row) => sum + (Number(row.value) || 0), 0);
    if (groupedValue <= 0) {
        return { pieItems: head, groupedCount: 0, groupedValue: 0 };
    }
    return {
        pieItems: [
            ...head,
            {
                id: "others",
                label: othersLabel,
                value: groupedValue,
                isOthers: true,
                color: OTHERS_COLOR,
                children: tail,
            },
        ],
        groupedCount: tail.length,
        groupedValue,
    };
};

export const DEAL_STATUS_META = {
    open: { label: "Open", color: "#1d4ed8", bg: "#dbeafe" },
    won:  { label: "Won",  color: "#065f46", bg: "#d1fae5" },
    lost: { label: "Lost", color: "#be123c", bg: "#fee2e2" },
};

export const fmtValue = (val) => {
    if (!val && val !== 0) return "—";
    const n = parseFloat(val);
    if (n >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
    if (n >= 1000)   return `₹${(n / 1000).toFixed(1)}k`;
    return `₹${n}`;
};

export const formatSourceLabel = (source) => {
    const s = (source || "").trim() || "Unknown";
    if (s === "Unknown") return s;
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatWindowDate = (value) => {
    if (!value) return "";
    const d = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const normalizeBySourceResponse = (payload) => {
    const raw = payload?.data ?? payload ?? {};
    const rows = Array.isArray(raw.by_source) ? raw.by_source : [];
    const leadsBySource = rows.map((r) => ({
        source: formatSourceLabel(r.source),
        count: Number(r.contacts_count) || 0,
    }));
    const total = Number(raw.total) || leadsBySource.reduce((sum, r) => sum + r.count, 0);
    return { leadsBySource, total };
};

export const normalizeDealStatusCounts = (payload) => {
    const raw = payload?.data ?? payload ?? {};
    const deals_open = Number(raw.deals_open) || 0;
    const deals_won = Number(raw.deals_won) || 0;
    const deals_lost = Number(raw.deals_lost) || 0;
    return {
        months: Number(raw.months) || 1,
        from: raw.from || null,
        to: raw.to || null,
        deals_open,
        deals_won,
        deals_lost,
        deals_total: Number(raw.deals_total) || (deals_open + deals_won + deals_lost),
    };
};

export const dealStatusWinRate = ({ deals_won = 0, deals_lost = 0 } = {}) => {
    const closed = deals_won + deals_lost;
    if (closed <= 0) return null;
    return Math.round((deals_won / closed) * 100);
};
